import { render, staticRenderFns } from "./simplifyParkingSpaceFee.vue?vue&type=template&id=2b63d8ba&scoped=true"
import script from "./simplifyParkingSpaceFee.vue?vue&type=script&lang=js"
export * from "./simplifyParkingSpaceFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyParkingSpaceFee.vue?vue&type=style&index=0&id=2b63d8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63d8ba",
  null
  
)

export default component.exports